import {
  INVENTORY_PURCHASE_ORDER_PAGE_REQUEST,
  INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_SET_OUTLETS,
  INVENTORY_PURCHASE_ORDER_PURCHASE_ORDER_REQUEST,
  INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN,
  INVENTORY_PURCHASE_ORDER_CLOSE_RIGHT_COLUMN,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_ROW,
  INVENTORY_PURCHASE_ORDER_SET_TOTAL_PAGE,
  INVENTORY_PURCHASE_ORDER_SET_CURRENT_PAGE,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_IDS,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_DATE,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_NAMESPACE,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_KEYWORD,
  INVENTORY_PURCHASE_ORDER_EXPORT_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_STATUS,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_DONE,
  INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER_DETAIL,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_PRINT,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_RESEND_EMAIL,
  INVENTORY_PURCHASE_ORDER_SET_SUPPLIERS,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_CREATE_PO,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_CANCEL,
  INVENTORY_PURCHASE_ORDER_UPDATE_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_SHOW_MODAL_ITEM,
  INVENTORY_PURCHASE_ORDER_CLOSE_MODAL_ITEM,
  INVENTORY_PURCHASE_ORDER_IS_LOADING,
  INVENTORY_PURCHASE_ORDER_SET_DATA_SEARCH,
  INVENTORY_PURCHASE_ORDER_GET_ITEMS_FROM_API,
  INVENTORY_PURCHASE_ORDER_SET_SELECTED_OUTLET,
  INVENTORY_PURCHASE_ORDER_SET_ADDED_ITEM,
  INVENTORY_PURCHASE_ORDER_SET_MODAL_DATA_FORM,
  INVENTORY_PURCHASE_ORDER_ADD_ITEM_TO_FORM,
  INVENTORY_PURCHASE_ORDER_ON_CANCEL_MODAL_ADD_ITEM,
  INVENTORY_PURCHASE_ORDER_CREATE_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_CREATE_AND_FULFILLED_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_EDIT_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_FORM,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_EDIT,
  INVENTORY_PURCHASE_ORDER_SHOW_CONFIRM_SUBMIT_MODAL,
  INVENTORY_PURCHASE_ORDER_HIDE_CONFIRM_SUBMIT_MODAL,
  INVENTORY_PURCHASE_ORDER_SET_IS_ITEM_ADDED,
  INVENTORY_PURCHASE_ORDER_SET_FIRST_ITEMS,
  INVENTORY_PURCHASE_ORDER_SHOW_IMPORT_MODAL,
  INVENTORY_PURCHASE_ORDER_HIDE_IMPORT_MODAL,
  INVENTORY_PURCHASE_ORDER_ON_SUCCESS_IMPORT
} from './constants'

export function setPurchaseOrders (purchaseOrders) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER, payload: {purchaseOrders}}
}

export function pageRequest () {
  return {type: INVENTORY_PURCHASE_ORDER_PAGE_REQUEST, payload: {}}
}

export function setOutlets (outlets) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_OUTLETS, payload: {outlets}}
}

export function purchaseOrderRequest (namespace, params, previousPurchaseOrders) {
  return {type: INVENTORY_PURCHASE_ORDER_PURCHASE_ORDER_REQUEST, payload: {namespace, params, previousPurchaseOrders}}
}

export function openRightColumn () {
  return {type: INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN, payload: {}}
}

export function closeRightColumn () {
  return {type: INVENTORY_PURCHASE_ORDER_CLOSE_RIGHT_COLUMN, payload: {}}
}

export function openRightColumnAsForm () {
  return {type: INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN, payload: {rightColumnState: 'form'}}
}

export function openRightColumnAsDetail () {
  return {type: INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN, payload: {rightColumnState: 'detail'}}
}

export function onClickRow (purchaseOrder, namespace) {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CLICK_ROW, payload: {purchaseOrder, namespace}}
}

export function setTotalPage (page) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_TOTAL_PAGE, payload: {page}}
}

export function setCurrentPage (page) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_CURRENT_PAGE, payload: {page}}
}

export function onChangeOutletIds (outletIds, namespace, params) {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_IDS, payload: {outletIds, params, namespace}}
}

export function onChangeDate (startDate, endDate, namespace, params) {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CHANGE_DATE, payload: {startDate, endDate, params, namespace}}
}

export function onChangeNamespace (namespace, params) {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CHANGE_NAMESPACE, payload: {namespace, params}}
}

export function onChangeKeyword (keyword, namespace, params) {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CHANGE_KEYWORD, payload: {keyword, namespace, params}}
}

export function onChangeStatus (status, namespace, params) {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CHANGE_STATUS, payload: {status, namespace, params}}
}

export function exportPurchaseOrder (params, filename, outletId) {
  return {type: INVENTORY_PURCHASE_ORDER_EXPORT_PURCHASE_ORDER, payload: {params, filename, outletId}}
}

export function onClickDone () {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CLICK_DONE, payload: {}}
}

export function onClickPrint (purchaseOrder) {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CLICK_PRINT, payload: {purchaseOrder}}
}

export function setPurchaseOrderDetail (purchaseOrder) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER_DETAIL, payload: {purchaseOrder}}
}

export function onClickResendEmail (purchaseOrder) {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CLICK_RESEND_EMAIL, payload: {purchaseOrder}}
}

export function setSuppliers (suppliers) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_SUPPLIERS, payload: {suppliers}}
}

export function onClickCreatePO (outletIds) {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CLICK_CREATE_PO, payload: {outletIds}}
}

export function onClickCancel () {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CLICK_CANCEL, payload: {}}
}

export function updatePurchaseOrders (purchaseOrder, status) {
  return {type: INVENTORY_PURCHASE_ORDER_UPDATE_PURCHASE_ORDER, payload: {purchaseOrder, status}}
}

export function showModalItemPurchase () {
  return {type: INVENTORY_PURCHASE_ORDER_SHOW_MODAL_ITEM, payload: {}}
}

export function closeModalItemPurchase () {
  return {type: INVENTORY_PURCHASE_ORDER_CLOSE_MODAL_ITEM, payload: {}}
}

export function isLoadingItem (isLoading) {
  return {type: INVENTORY_PURCHASE_ORDER_IS_LOADING, payload: {isLoading}}
}

export function setDataSearch (items) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_DATA_SEARCH, payload: {items}}
}

export function getItemsFromAPI (params) {
  return {type: INVENTORY_PURCHASE_ORDER_GET_ITEMS_FROM_API, payload: {params}}
}

export function setSelectedOutlet (outletId) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_SELECTED_OUTLET, payload: {outletId}}
}

export function setAddedItem (item) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_ADDED_ITEM, payload: {item}}
}

export function setModalDataForm (namespace, data, itemPurchase) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_MODAL_DATA_FORM, payload: {namespace, data, itemPurchase}}
}

export function addItemtoPOForm (itemVariantValue, formPO, namespace) {
  return {type: INVENTORY_PURCHASE_ORDER_ADD_ITEM_TO_FORM, payload: {itemVariantValue, formPO, namespace}}
}

export function onCancelModalAddItem () {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CANCEL_MODAL_ADD_ITEM, payload: {}}
}

export function createPO (namespace, data, date) {
  return {type: INVENTORY_PURCHASE_ORDER_CREATE_PURCHASE_ORDER, payload: {namespace, data, date}}
}

export function createAndFulfilledPO (namespace, data, date) {
  return {type: INVENTORY_PURCHASE_ORDER_CREATE_AND_FULFILLED_PURCHASE_ORDER, payload: {namespace, data, date}}
}

export function onClickEdit (purchaseOrder) {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CLICK_EDIT, payload: {purchaseOrder}}
}

export function editPO (namespace, data) {
  return {type: INVENTORY_PURCHASE_ORDER_EDIT_PURCHASE_ORDER, payload: {namespace, data}}
}

export function onChangeOutletForm () {
  return {type: INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_FORM, payload: {}}
}

export function showConfirmSubmitModal (action) {
  return {type: INVENTORY_PURCHASE_ORDER_SHOW_CONFIRM_SUBMIT_MODAL, payload: {action}}
}

export function hideConfirmSubmitModal () {
  return {type: INVENTORY_PURCHASE_ORDER_HIDE_CONFIRM_SUBMIT_MODAL, payload: {}}
}

export function setIsItemAdded (isAdded) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_IS_ITEM_ADDED, payload: {isAdded}}
}

export function setFirstItems (firstItems) {
  return {type: INVENTORY_PURCHASE_ORDER_SET_FIRST_ITEMS, payload: {firstItems}}
}

export function showImportModal () {
  return {type: INVENTORY_PURCHASE_ORDER_SHOW_IMPORT_MODAL, payload: {}}
}

export function hideImportModal () {
  return {type: INVENTORY_PURCHASE_ORDER_HIDE_IMPORT_MODAL, payload: {}}
}

export function onSuccessImport () {
  return {type: INVENTORY_PURCHASE_ORDER_ON_SUCCESS_IMPORT, payload: {}}
}



// WEBPACK FOOTER //
// ./app/actions/inventory/purchaseOrder/purchaseOrder.js